import React from "react";
//************************************************************************ /
// FOOTER CTA
// Colored, full-width footer that sits at the bottom of the Community Board,
// on top of the footers for the organization and cotribute.
//************************************************************************ /

import Link from "next/link";
import { Button } from "@dreambigger/design-system/src";
import { useGA } from "@dreambigger/shared/src/hooks";
import { optimizeCloudinaryImg } from "@dreambigger/shared/src/utils";

export interface FooterCTAProps {
  ctaText?: string;
  linkText?: string;
  image?: string;
  ctaUrl?: string;
  background?: string;
}

const DEFAULT_IMAGE =
  "https://res.cloudinary.com/cotribute/image/upload/v1512507369/Community%20Board%20BG%20PNG%27s/2.png";

const FooterCta = ({
  ctaText,
  linkText,
  image,
  ctaUrl,
  background,
}: FooterCTAProps) => {
  const googleAnalytics = useGA();

  const handleCtaClick = () => {
    googleAnalytics.event({
      category: "Event Detail Page", // This is a mistake, but it was captured this way in legacy app.
      action: "CTA Click - Footer - " + window.location.href,
      label: "LEARN MORE-" + window.location.pathname,
      value: 1,
    });
  };

  return (
    // FOOTER CONTAINER
    <div
      className={`flex flex-column lg_flex-row pv-4 lg_pv-5 justify-center items-center pa-5 w-100 ${
        !background && "bg-cta"
      }`}
      style={background ? { background } : { background: "black" }} // Uses provided background, then bg-cta, then a default black.
    >
      {/* Left Column - Image */}
      <div className="mb-4 lg_mr-6 lg_mb-0" style={{ maxWidth: "450px" }}>
        <img
          src={optimizeCloudinaryImg(image || DEFAULT_IMAGE)}
          className="w-100 h-auto"
          style={{ border: "solid white 1px" }}
          loading="lazy"
        />
      </div>
      {/* Right Column - Call To Action Text and Button Link */}
      {ctaUrl && (
        <div className="flex flex-column content-center w-80 lg_w-30 lg_pa-6">
          <h3 className="f-5 fwb white mb-5">{ctaText}</h3>
          <Link href={ctaUrl}>
            <Button
              type="primary"
              className={`min-w-33 self-center`}
              onClick={handleCtaClick}
            >
              {linkText}
            </Button>
          </Link>
        </div>
      )}
    </div>
  );
};

export default FooterCta;
